// assets/product-form.js
// Decanter limit: any product with "wine decanter" in its title (not case-sensitive)
const DECANTER_KEYWORD = 'wine decanter';
const isDecanter = (title) => (title || '').toLowerCase().includes(DECANTER_KEYWORD);
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id], [name*="[id]"]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // Initial cart UI reference (we also re-resolve at submit time)
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('#CartDrawer') ||
          document.querySelector('#Cart-Drawer') ||
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('.cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.updateButton = this.querySelector('button[name="personalisation-update"]');
        this.quantityInput = this.form.querySelector('[name="quantity"]');
        // Clear any previous error when clicking buttons
        this.querySelectorAll('button').forEach((button) => {
          button.addEventListener('click', () => this.handleErrorMessage());
        });
        if (this.updateButton) {
          this.updateButton.addEventListener('click', this.onUpdateHandler.bind(this));
        }
        if (document.querySelector('cart-drawer')) {
          if (this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          if (this.updateButton) this.updateButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      onUpdateHandler(evt) {
        if (this.updateButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.updateButton.setAttribute('aria-disabled', true);
        this.updateButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        // Make sure we have the cart UI when updating
        this.cart =
          this.cart ||
          document.querySelector('cart-notification, cart-drawer, #CartDrawer, #Cart-Drawer, [data-cart-drawer], .cart-drawer');
        const firstInput = this.querySelector('[id*="PersonalisationFirstLine-"]');
        const secondInput = this.querySelector('[id*="PersonalisationSecondLine-"]');
        const sections = this.cart?.getSectionsToRender
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];
        const cartChangeData = {
          id: this.updateButton.dataset.key,
          properties: {
            'First line': (firstInput?.value || '').toUpperCase(),
            'Second line': (secondInput?.value || '').toUpperCase(),
            '_group_id': this.updateButton.dataset.groupId
          },
          sections,
          sections_url: window.location.pathname
        };
        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartChangeData)
        })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
              console.log('parsedState.errors', parsedState.errors);
              return;
            }
            const cartBubble = document.querySelector('#cart-icon-bubble');
            const stickyNavSwitchedButton = document.querySelector('.sticky-nav__element--show');
            if (
              stickyNavSwitchedButton &&
              parsedState.item_count === 0 &&
              !window.location.pathname.includes('/products/') &&
              !window.location.pathname.includes('/collections/')
            ) {
              stickyNavSwitchedButton.classList.remove('hidden');
              cartBubble?.classList.add('sticky-nav__element--hide');
            }
            this.cart?.renderContents(parsedState);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              cartData: parsedState,
              variantId: undefined
            });
            const prevSibling = evt.target.previousElementSibling;
            if (prevSibling && prevSibling.id.includes('ModalClose')) {
              prevSibling.click();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.updateButton.classList.remove('loading');
            this.updateButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      // Limit logic: block the add if it would take decanters in the basket over MAX
      canProceedAdd() {
        const hasMsg = Boolean(window.cartStrings?.decanters_error);
        if (!isDecanter(this.dataset.productName) || !hasMsg) return true;
        // Safe root for counting (drawer if present; otherwise document -> count stays 0)
        this.cart =
          this.cart ||
          document.querySelector('cart-notification, cart-drawer, #CartDrawer, #Cart-Drawer, [data-cart-drawer], .cart-drawer');
        const root = this.cart || document;
        let counter = 0;
        root.querySelectorAll('.cart-item').forEach((item) => {
          if (isDecanter(item.dataset.productName) && item.dataset.qty) {
            const qty = parseInt(item.dataset.qty, 10);
            if (!Number.isNaN(qty)) counter += qty;
          }
        });
        const toAdd = this.quantityInput ? (parseInt(this.quantityInput.value, 10) || 1) : 1;
        const MAX = 4;
        if (counter + toAdd > MAX) {
          // Show translated HTML message
          this.handleErrorMessage(window.cartStrings.decanters_error);
          // Reset UI to non-loading state (your original behavior)
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          return false;
        }
        return true;
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        // Always re-resolve the cart UI now (ensures sections + drawer rendering)
        this.cart =
          this.cart ||
          document.querySelector('cart-notification, cart-drawer, #CartDrawer, #Cart-Drawer, [data-cart-drawer], .cart-drawer');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        // Clear previous error
        this.handleErrorMessage();
        // Loading state
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        // Only append sections if we truly have a cart UI instance
        if (this.cart?.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }
        // Enforce the decanter cap before we post
        if (!this.canProceedAdd()) return;
        // Personalisation normalisation
        const currentTime = Date.now();
        if (formData.has('items[1][properties][First line]')) {
          formData.set(
            'items[1][properties][First line]',
            `${formData.get('items[1][properties][First line]').toUpperCase()}`
          );
        }
        if (formData.has('items[1][properties][Second line]')) {
          formData.set(
            'items[1][properties][Second line]',
            `${formData.get('items[1][properties][Second line]').toUpperCase()}`
          );
        }
        if (formData.has('items[0][properties][_group_id]')) {
          formData.set('items[0][properties][_group_id]', `${currentTime}`);
        }
        if (formData.has('items[1][properties][_group_id]')) {
          formData.set('items[1][properties][_group_id]', `${currentTime}`);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Shopify returned an error (e.g., sold out)
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Try once more to find the cart UI before redirecting
              this.cart =
                document.querySelector('cart-notification, cart-drawer, #CartDrawer, #Cart-Drawer, [data-cart-drawer], .cart-drawer');
              if (this.cart) {
                this.cart.renderContents(response);
              } else {
                window.location = window.routes.cart_url; // true fallback
              }
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const prevSibling = evt.submitter?.previousElementSibling;
              if (prevSibling && prevSibling.id.includes('ModalClose')) prevSibling.click();
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        // Support both common selectors
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message, [data-error-message]');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) {
          let msg = errorMessage;
          // If HTML arrived escaped ("&lt;p&gt;…"), decode once so it renders
          if (typeof msg === 'string' && msg.includes('&lt;')) {
            msg = new DOMParser().parseFromString(msg, 'text/html').documentElement.textContent;
          }
          this.errorMessage.innerHTML = msg; // render HTML (safe: comes from locale files)
        }
      }
    }
  );
}